import * as ActionType from "../actionType";
import { fetchHomePageApi } from "../../services/page/home";

const getHomePageAction = () => {
  return async dispatch => {
    dispatchHomePage(dispatch);
  };
};

const dispatchHomePage = dispatch => {
  fetchHomePageApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_PAGE_HOME,
      data
    });
  });
};

export { getHomePageAction, dispatchHomePage };



// WEBPACK FOOTER //
// ./src/actions/page/home.js